var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "success-popover" }, [
    _c("div", { staticClass: "container h-100" }, [
      _c("div", { staticClass: "row h-100 align-items-center" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h2", {
            staticClass: "text-white mb-40",
            domProps: { innerHTML: _vm._s(_vm.title) }
          }),
          _vm._v(" "),
          _c("p", {
            staticClass: "text-white font-weight-light mb-40",
            domProps: { innerHTML: _vm._s(_vm.description) }
          }),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-accent text-white arrow-right",
              attrs: { href: _vm.route("nl.home") }
            },
            [
              _c("span", { domProps: { innerHTML: _vm._s(_vm.cta) } }),
              _vm._v(" "),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(_vm.svg("arrow-right", "arrow-right"))
                }
              })
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }